// extracted by mini-css-extract-plugin
export var wrapper = "SuccessModal-module--wrapper--40920";
export var text = "SuccessModal-module--text--0eb6d";
export var icon = "SuccessModal-module--icon--44f6f";